import Title from "../components/Title/Title";

export function Home() {
  return <Title />;
}
